export function clearAddressBumperValues(){
    $('#service-address-bumper input[name="address"]').val('');
    $('#service-address-bumper input[name="address2"]').val('');
    $('#service-address-bumper input[name="city"]').val('');
    $('#service-address-bumper select[name="state"]').val('');
    $('#service-address-bumper input[name="zipcode"]').val('');
}